// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2612229c","187":"c0b2e386","313":"1c5b6761","451":"fe42c230","510":"11867803","696":"70ea2aea","895":"182a5f39","969":"1a734e64"}[chunkId] + ".chunk.js";
};